module.exports = __webpack_public_path__ + "assets/img/fc063c6cd21438de47b9d8a61d72a5f8.png";